import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ssoToken, setLastClicked } from '../store/actions/auth';

const LoginSSO = () => {
  const lastClicked = useSelector((state) => state.auth.lastClicked);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const getQueryParams = (search) => {
    return new URLSearchParams(search);
  };
  const queryParams = getQueryParams(location.search);
  const token = queryParams.get('token');
  const loginReturn = <div>Redirecting to external site...</div>;

  useEffect(() => { 
    if (token) {
      dispatch(ssoToken(token));
      dispatch(setLastClicked(new Date())); // Dispatch action to set lastClicked
      history.push(`/`);
    }
  }, [token]);

  return loginReturn;
};

export default LoginSSO;